import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ViewAndUpdateConfig {
  constructor(private http:HttpClient) { }

  getPackageConfig(){
    return this.http.get(environment.apiUrl + "packageConfig/get")
  }
  packageConfigUpdate(data:any){
    return this.http.post(environment.apiUrl + "packageConfig/update", data)
  }
  getPackerMoverConfig(){
    return this.http.get(environment.apiUrl + "packerMoverConfig/get")
  }
  packerMovereConfigUpdate(data:any){
    return this.http.post(environment.apiUrl + "packerMoverConfig/update", data)
  }
  getQrConfigTable(data:any){
    return this.http.post(environment.apiUrl + "qrCodeConfig/get/all" , data);
  }
  getApplcationConfigTable(){
    return this.http.get(environment.apiUrl + "appConfig/get");
  }
  applicationConfigUpdate(data:any){
    return this.http.post(environment.apiUrl + "appConfig/update", data)
  }
  addImage(file ){
    const formData = new FormData(); 
    formData.append("files", file);
    return this.http.post( environment.filePath, formData )
  }
  getRange(){
    return this.http.get(environment.apiUrl + "range/get/all")
  }
  updateRange(data){
    return this.http.post(environment.apiUrl + "range/update" ,data)
  }
  getCupan(){
    return this.http.get(environment.apiUrl + "coupon/get")
  }
  updateCoupan(data){
    return this.http.post(environment.apiUrl + "coupon/update", data)
  }
}